import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingTopSpendingParentsAPI = async (params?: {
  format?: string;
}) => {
  const response = await baseAPI.get<string>(
    '/reporting/top-spending-parents',
    {
      params,
      responseType: 'text',
    },
  );
  return response.data;
};

export const useReportingTopSpendingParents = (params?: {
  format?: string;
}) => {
  return useQuery({
    queryKey: [KEYS.TOP_SPENDING_PARENTS, params],
    queryFn: () => reportingTopSpendingParentsAPI(params),
    enabled: !!params?.format,
  });
};
